import { Component, OnInit, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '../../../../_services/translate.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../_services/api.service';
import { AnpiService } from '../../../../_services/anpi-code.service';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../../../_services/authentication.service';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  login: any;
  url: any;
  currentLang: any;
  employee = false;
  accountDetails: any;
  currentUser: any;
  isBusiness = false;
  currentValue: any;
  response: any;
  public languageForm: FormGroup;
  messageTitle: any;
  messageDescription: any;
  is_cnamgsPdf: boolean;
  is_cnssPdf: boolean;
  mobileEmployeesMenuOpen = false;

  constructor(private ngZone: NgZone,
    private router: Router,
    private translate: TranslateService,
    private api: ApiService,
    private formBuilder: FormBuilder,
    private anpiService: AnpiService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    private authenticationService: AuthenticationService) { }

  navigateToAddEmployee() {
    this.router.navigate(['/employees'], { queryParams: { openModal: 'addEmployee' } });
  }

  navigateToCnssEmployeeRegistration() {
    this.router.navigate(['/employees'], { queryParams: { openModal: 'cnssEmployeeRegistration' } });
  }

  navigateToCnamgsEmployeeRegistration() {
    this.router.navigate(['/employees'], { queryParams: { openModal: 'cnamgsEmployeeRegistration' } });
  }

  toggleMobileEmployeesMenu() {
    this.mobileEmployeesMenuOpen = !this.mobileEmployeesMenuOpen;
  }

  ngOnInit() {
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      this.login = this.accountDetails.current_user;
      console.log("36 login value:", this.login)
      if (this.login == "1") {
        this.employee = false;
      } else {
        this.employee = true;
      }
      if (this.accountDetails.GNI == "1") {
        this.isBusiness = true;
      }
    }
    this.anpiService.accountEvent.subscribe(() => {
      const data = localStorage.getItem('currentUserDetails');
      console.log("33", data)
      if (data) {
        this.accountDetails = JSON.parse(data);
        this.login = this.accountDetails.current_user;
        console.log("36 login value:", this.login)
        if (this.login == "1") {
          this.employee = false;
        } else {
          this.employee = true;
        }
        if (this.accountDetails.GNI == "1") {
          this.isBusiness = true;
        }
      }
    });

    this.ngZone.run(() => {
      this.url = window.location.pathname.split('/')[1];

      console.log("url is", this.url)
    });

    this.languageForm = this.formBuilder.group({
      lang: ['', []],
    });
    this.currentLang = localStorage.getItem('language') || "fr";
    this.languageForm.get('lang').setValue(this.currentLang);
    if (this.currentLang == 'fr') {
      $('.checkbox').prop('checked', false);
    } else {
      $('.checkbox').prop('checked', true);
    }
    if (this.currentLang == 'fr') {
      $('.myCheckbox').prop('checked', true);
      $("#lang").text("FR");
      console.log("language is french")
    } else {
      $('.myCheckbox').prop('checked', false);
      $("#lang").text("EN");
      console.log("language is english")
    }
    this.currentValue = this.authenticationService.currentUserValue;
    console.log("144", this.currentValue)
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.currentValue = this.authenticationService.currentUserValue;
      const data = localStorage.getItem('currentUserDetails');
      console.log(data)
      if (data) {
        this.accountDetails = JSON.parse(data);
        this.login = this.accountDetails.current_user;
        console.log("36 login value:", this.login)
        if (this.login == "1") {
          this.employee = false;
        } else {
          this.employee = true;
        }
        console.log(this.accountDetails)
        if (this.accountDetails.GNI == "1") {
          this.isBusiness = true;
        }
      }
    }, 1000)
  }

  openNav() {
    document.getElementById("mySidenav").style.width = "305px";
    document.getElementById("main").style.marginRight = "0px";
    document.getElementById("menuOverlay").style.display = "block";

  }

  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("main").style.marginRight = "0";
    document.getElementById("menuOverlay").style.display = "none";
    this.mobileEmployeesMenuOpen = false;
  }


  getCnamgs() {
    this.router.navigate(['/cnamgs-report'], { state: { data: 'cnamgs' } });
  }
  getCnamgsemployee() {
    this.router.navigate(['/cnss/cnamgs'], { state: { data: 'cnamgs' } });
  }
  setLang(lang) {
    console.log('aaa')
    this.currentLang = lang;
    console.log("69", lang)
    var useLang = { language: this.currentLang };
    console.log(useLang)
    this.translate.setCurrentLangage(useLang);
    localStorage.setItem('language', lang);
    this.changeLang();
  }
  changeLang() {
    this.translate.use(this.currentLang);
    console.log(this.translate.currentLanguageValue)
  }
  checkValue(e) {
    console.log(e)
    if (e == true) {
      this.setLang('fr');
      $("#lang").text("FR");
    } else {
      this.setLang('en');
      $("#lang").text("EN");
    }
  }

  getChangelang(e) {
    if (e.target.checked == true) {
      var lang = 'en';
    } else {
      lang = 'fr';
    }
    this.onChangeLanguage(lang);
    this.anpiService.faqChangEvent();
  }

  getBusiness() {
    return localStorage.getItem('business');
  }

  getCnssPage() {
    if (this.accountDetails.cnss == 1) {
      this.router.navigate(['/cnss-reportList']);
    } else {
      this.router.navigate(['/cnss-reports']);
    }
  }
  getCnamgsPage() {
    if (this.accountDetails.cnamgs == 1) {
      this.router.navigate(['/cnamgs-reportlist']);
    } else {
      this.router.navigate(['/cnamgs-report']);
    }
  }
  onChangeLanguage(lang) {
    if (!lang) {
      return;
    }

    const currentUser = this.authenticationService.currentUserValue || JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser) {
      this.setLang(lang);
      return;
    }

    this.ngxUiLoaderService.start();
    let data = {
      language: lang
    }
    console.log(data)
    this.api.changeLangauge(data).pipe(first())
      .subscribe(data => {
        this.ngxUiLoaderService.stop();
        this.response = data;
        if (this.response.status == 200) {
          this.setLang(lang)
        } else {
          this.snackBar.open(this.response.message, "OK", {
            duration: 5000,
          });
        }

      },
        error => {
          this.ngxUiLoaderService.stop();
        });

  }
  logout() {
    this.authenticationService.logout();
  }

  openPaymentDetailsModal() {


    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);

      if (this.accountDetails.BankDetails == '1') {
        this.router.navigate(['/profile'], { state: { profile_section: 'sidenav3' } });
      } else {
        $('#bankAccountModal').modal('show');

      }
    }
  }


  goTocnamgsEmployer() {
    if (this.accountDetails.cnamgs == 0 || this.accountDetails.cnamgs == 3) {
      this.router.navigate(['/cnamgs-form']);
    } else if (this.accountDetails.cnamgs == 2) {
      this.messageTitle = 'CNAMGS Approval is Pending';
      this.messageDescription = 'The information inserted has been sent for verification by the CNAMGS and is awaiting activation';
      $('#headerMessageModal').modal('show');
      this.is_cnamgsPdf = true;
    } else if (this.accountDetails.cnamgs == 1) {
      const url = this.accountDetails.cnamgs_url;
      window.open(url, '_blank');
    }
  }

  goTocnssEmployer() {
    if (this.accountDetails.cnss == 0 || this.accountDetails.cnss == 3) {
      this.router.navigate(['/cnss-approval-form']);
    } else if (this.accountDetails.cnss == 2) {
      this.messageTitle = 'CNSS Approval is Pending';
      this.messageDescription = 'The information inserted has been sent for verification by the CNSS and is awaiting activation';
      $('#headerMessageModal').modal('show');
      this.is_cnssPdf = true;
    } else if (this.accountDetails.cnss == 1) {
      const url = this.accountDetails.cnss_url;
      window.open(url, '_blank');
    }
  }

  closeModal() {
    $('#headerMessageModal').modal('hide');
    this.is_cnamgsPdf = false;
    this.is_cnssPdf = false;
    this.messageTitle = '';
    this.messageDescription = '';

  }


}
